"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MESSAGE = void 0; // Live Search Component

var MESSAGE = "Searching...";
exports.MESSAGE = MESSAGE;
var _default = {
  MESSAGE: MESSAGE
};
exports["default"] = _default;